import { render, staticRenderFns } from "./DashboardCellAppInfo.vue?vue&type=template&id=67e13390&scoped=true&"
import script from "./DashboardCellAppInfo.vue?vue&type=script&lang=js&"
export * from "./DashboardCellAppInfo.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "67e13390",
  null
  ,true
)

export default component.exports